"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.batchUnbindProducts = batchUnbindProducts;
exports.bindProductToClinics = bindProductToClinics;
exports.bindProductToDistributors = bindProductToDistributors;
exports.bindProductToSuppliers = bindProductToSuppliers;
exports.bindProductsToClinic = bindProductsToClinic;
exports.deleteProduct = deleteProduct;
exports.getClinicProducts = getClinicProducts;
exports.getClinicProductsCount = getClinicProductsCount;
exports.getDistributorList = getDistributorList;
exports.getProductDetail = getProductDetail;
exports.getProductList = getProductList;
exports.getProductsNotInClinic = getProductsNotInClinic;
exports.getSupplierList = getSupplierList;
exports.getSupplierListByType = getSupplierListByType;
exports.saveOrUpdateProduct = saveOrUpdateProduct;
exports.unbindProduct = unbindProduct;
exports.unbindProductPost = unbindProductPost;
exports.unbindProductsFromClinic = unbindProductsFromClinic;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
/**
 * 获取商品列表
 * @param {Object} params
 */
function getProductList(params) {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/product/list',
      method: 'get',
      params: params
    }).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 新增或更新商品
 * @param {Object} data
 */
function saveOrUpdateProduct(data) {
  // 处理图片数据
  var formattedData = _objectSpread({}, data);

  // 确保imageList是数组
  if (formattedData.imageList && typeof formattedData.imageList === 'string') {
    formattedData.imageList = formattedData.imageList.split(',').filter(function (url) {
      return url.trim() !== '';
    });
  }

  // 确保tagList是数组
  if (formattedData.tagList && typeof formattedData.tagList === 'string') {
    formattedData.tagList = formattedData.tagList.split(',').filter(function (tag) {
      return tag.trim() !== '';
    });
  }

  // 确保customerIdList是数组
  if (formattedData.customerIdList && typeof formattedData.customerIdList === 'string') {
    formattedData.customerIdList = formattedData.customerIdList.split(',').filter(function (id) {
      return id.trim() !== '';
    }).map(function (id) {
      return parseInt(id);
    });
  }
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/product/saveOrUpdate',
      method: 'post',
      data: formattedData
    }).then(function (response) {
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 删除商品
 * @param {number} id
 */
function deleteProduct(id) {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/product/delete',
      method: 'get',
      params: {
        id: id
      }
    }).then(function (response) {
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 获取商品详情
 * @param {number} id
 */
function getProductDetail(id) {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/product/getProductDetail',
      method: 'get',
      params: {
        id: id
      }
    }).then(function (response) {
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 获取供应商列表
 * @param {Object} params 查询参数
 */
function getSupplierList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/business/supplier/autoList',
      method: 'GET',
      params: _objectSpread(_objectSpread({}, params), {}, {
        temp: new Date().getTime() // Adding timestamp as per the request format
      })
    }).then(function (response) {
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 绑定诊所和产品
 * @param {Object} data 包含productId和clinicIds数组
 */
function bindProductToClinics(data) {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/product/bindClinics',
      method: 'post',
      data: data
    }).then(function (response) {
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 绑定供应商和产品
 * @param {Object} data 包含productId和supplierIds数组
 */
function bindProductToSuppliers(data) {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/product/bindSuppliers',
      method: 'post',
      data: data
    }).then(function (response) {
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 获取供应商列表（带类型）
 * @param {Object} params 查询参数，可以包含productType
 */
function getSupplierListByType() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new Promise(function (resolve, reject) {
    (0, _requestMapi.default)({
      // url: '/admin/business/supplier/autoListByType',
      url: '/mapi/user/supplier/autoListByType',
      method: 'GET',
      params: _objectSpread(_objectSpread({}, params), {}, {
        temp: new Date().getTime() // Adding timestamp as per the request format
      })
    }).then(function (response) {
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 获取分销商列表
 * @param {Object} params 查询参数
 */
function getDistributorList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/customers/options',
      method: 'GET',
      params: params
    }).then(function (response) {
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 绑定分销商和产品
 * @param {Object} data 包含productId和customerIds数组
 */
function bindProductToDistributors(data) {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/product/bindDistributors',
      method: 'post',
      data: data
    }).then(function (response) {
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 获取未添加到指定诊所的商品列表
 * @param {number} clinicId 诊所ID
 * @param {Object} params 其他查询参数
 */
function getProductsNotInClinic(clinicId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/product/listNotInClinic',
      method: 'get',
      params: _objectSpread({
        clinicId: clinicId
      }, params)
    }).then(function (response) {
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 批量绑定商品到诊所
 * @param {Object} data 包含clinicId和productIds数组
 */
function bindProductsToClinic(data) {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/clinic/bindProducts',
      method: 'post',
      data: data
    }).then(function (response) {
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 获取已绑定到指定诊所的商品列表
 * @param {number} clinicId 诊所ID
 * @param {Object} params 其他查询参数
 */
function getClinicProducts(clinicId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/clinic/products',
      method: 'get',
      params: {
        clinicId: clinicId,
        keyword: params.keyword || undefined,
        status: params.status !== null ? params.status : undefined,
        page: params.page || 1,
        limit: params.limit || 10
      }
    }).then(function (response) {
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 从诊所解绑商品
 * @param {Object} data 包含clinicId和productIds数组
 */
function unbindProductsFromClinic(data) {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/clinic/batchUnbindProducts',
      method: 'post',
      data: data
    }).then(function (response) {
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 解绑诊所商品（GET请求）
 * @param {number} clinicId 诊所ID
 * @param {number} productId 商品ID
 */
function unbindProduct(clinicId, productId) {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/clinic/unbindProduct',
      method: 'get',
      params: {
        clinicId: clinicId,
        productId: productId
      }
    }).then(function (response) {
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 解绑诊所商品（POST请求版本）
 * @param {Object} data 包含clinicId和productId
 */
function unbindProductPost(data) {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/clinic/unbindProducts',
      method: 'post',
      data: data
    }).then(function (response) {
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 批量解绑诊所商品
 * @param {Object} data 包含clinicId和productIds数组
 */
function batchUnbindProducts(data) {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/clinic/batchUnbindProducts',
      method: 'post',
      data: data
    }).then(function (response) {
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 获取诊所绑定的商品数量
 * @param {number} clinicId 诊所ID
 */
function getClinicProductsCount(clinicId) {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/clinic/productsCount',
      method: 'get',
      params: {
        clinicId: clinicId
      }
    }).then(function (response) {
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}